import React from 'react'

const Footer = () => {
    return (
        <div className='max-w[1240px]  p-16  text-gray-300'  >
            <div className='flex justify-center'>
               <div>
               <h1 className='text-3xl font-bold text-[#00df9a] '>Learn Tech</h1>
                <div>
                    <h2 className='text-white text-xl'>Contact: +254 725 993 935</h2>
                    <p>Email: jobkilonzo95@gmail.com</p>
                </div>
               </div>
            </div>
        </div>
    )
}

export default Footer